export default __webpack_public_path__ + "static/media/Image_Govt1.7e0a2b0f.jpg";